'use strict';

angular.module('licensure.services')
    .factory('ComplaintActivityTracking', ['$http', '$q', function ($http, $q) {
        return {
            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/ComplaintActivityTracking/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },
            save: function (complaint_activity) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/ComplaintActivityTracking/';
                if (!isUndefined(complaint_activity.id)) {
                    method = 'PUT'
                    url += complaint_activity.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        complaint_activity: complaint_activity
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/ComplaintActivityTracking/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getActivityTrackingHistoryByComplaintID: function (complaintId) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/InvestigationsModule/InvestigationActivityTrackingHistory/Investigation/' + complaintId, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });

                return d.promise;
            },

            getActivityTrackingHistoryByID: function (activityTrackingHistoryId) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/InvestigationsModule/InvestigationActivityTrackingHistory/' + activityTrackingHistoryId, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });

                return d.promise;
            },

            deleteActivityTrackingHistory: function (activityTrackingHistoryId) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/InvestigationsModule/InvestigationActivityTrackingHistory/' + activityTrackingHistoryId, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });

                return d.promise;
            },
        }
    }])
;